import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.25 4.807V15a.75.75 0 0 0 1.5 0V4.807l1.72 1.72a.75.75 0 0 0 1.062-1.06L12.53 2.466a.75.75 0 0 0-1.064.004L8.468 5.467a.75.75 0 0 0 1.061 1.06z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M6.998 9.749c-.69 0-1.25.56-1.25 1.25v8.004c0 .69.56 1.25 1.25 1.25h10.004c.69 0 1.25-.56 1.25-1.25V11c0-.691-.56-1.251-1.25-1.251h-2a.75.75 0 0 1 0-1.5h2a2.75 2.75 0 0 1 2.75 2.75v8.004a2.75 2.75 0 0 1-2.75 2.75H6.998a2.75 2.75 0 0 1-2.75-2.75V11a2.75 2.75 0 0 1 2.75-2.751h2a.75.75 0 1 1 0 1.5z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }